import { FeedbackCategory } from './types';

export const MIN_DESCRIPTION_LENGTH = 10;

export const CATEGORY_CONFIG: Record<
  FeedbackCategory,
  {
    label: string;
    description: string;
    placeholder: string;
    color: string;
  }
> = {
  bug: {
    label: 'Bug Report',
    description: 'Something is broken',
    placeholder: 'Describe the bug: what happened, what you expected, steps to reproduce...',
    color: 'red',
  },
  feature: {
    label: 'Feature Request',
    description: 'Request a new feature',
    placeholder: 'Describe the feature you would like and how it would help...',
    color: 'blue',
  },
  general: {
    label: 'General',
    description: 'General feedback',
    placeholder: 'Share your thoughts, questions, or suggestions...',
    color: 'green',
  },
};

export const TARGETING_STYLES = `
  .targeting-highlight {
    outline: 2px solid rgba(59, 130, 246, 0.9) !important;
    outline-offset: 2px !important;
    box-shadow:
      0 0 0 1px rgba(59, 130, 246, 0.3),
      0 0 20px rgba(59, 130, 246, 0.4),
      inset 0 0 20px rgba(59, 130, 246, 0.05) !important;
  }

  @keyframes targetLock {
    0% { outline-width: 2px; box-shadow: 0 0 20px rgba(59, 130, 246, 0.4); }
    50% { outline-width: 4px; box-shadow: 0 0 40px rgba(59, 130, 246, 0.8); }
    100% { outline-width: 2px; box-shadow: 0 0 20px rgba(59, 130, 246, 0.4); }
  }

  .targeting-locked {
    animation: targetLock 0.4s ease-out !important;
  }
`;
